<template>
    <PopupBase v-model:visiblePopup="visible">
        <template #content>
            <div
                v-if="isLoading"
                class="w-full flex justify-center items-center my-4"
            >
                <SvgIcon
                    icon-name="loading-gray"
                    class="animate-spin h-12 w-12"
                />
            </div>
            <span v-else> {{ modalContent.content }}</span>
        </template>
        <template #action>
            <div v-if="isLoading" />
            <template v-else-if="modalContent.id==='confirm1'">
                <button
                    class="btn btn-accent rounded-full"
                    @click="handleClose"
                >
                    取消
                </button>
                <button
                    class="btn bg-error rounded-full border-0 text-white"
                    @click="popupConfirm"
                >
                    確定
                </button>
            </template>
            <!-- 保單變更情況下會用到 -->
            <template v-else-if="modalContent.id==='confirm2'">
                <button
                    class="btn btn-accent rounded-full"
                    @click="handleClose"
                >
                    取消
                </button>
                <button
                    class="btn bg-error rounded-full border-0 text-white"
                    @click="removeService(true)"
                >
                    確定刪除
                </button>
            </template>
            <template v-else-if="modalContent.id==='remove'">
                <button
                    class="btn btn-accent rounded-full"
                    @click="handleClose"
                >
                    取消
                </button>
            </template>
        </template>
        <Loading :isLoading="isLoading" />
    </PopupBase>
</template>

<script>
import { ref, watchEffect, toRefs } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
// import { beforeCancelTransactionItem } from '@/apis/system';
import { cancelTransactionItem, checkTransaction } from '@/apis/system';
import { beforeCancelItem } from '@/utils/changeItems/removeService';
import aplCatlCode from '@/json/aplCatlCode';
import PopupBase from '@/components/dialogs/Popup.vue';
import Loading from '@/components/Loading.vue';
import addService from '@/utils/changeItems/addService';
import routeName from '@/router/constant.js';
import { addAndInsertService } from '@/utils/changeItems/insertService';

export default {
    name: 'PopupRemove',
    components: {
        PopupBase,
        Loading
    },
    props: {
        visiblePopup: {
            type: Boolean,
            default: false,
        },
        code: {
            type: String,
            default: '',
        },
    },
    emits: ['update:visiblePopup', 'handleClose', 'popupConfirm', 'goNext'],
    setup(props, { emit }) {
        const { code, visiblePopup } = toRefs(props);
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const visible = ref(false);
        const isLoading = ref(false);
        const aplCatl = store.state.services.aplCatl;
        const modalContent = ref({
            id: 'confirm1',
            content: '確定刪除此變更項目？',
        });

        watchEffect(() => {
            visible.value = visiblePopup.value;
        });

        const handleClose = () => {
            isLoading.value = false;
            modalContent.value = {
                id: 'confirm1',
                content: '確定刪除此變更項目？',
            };
            emit('update:visiblePopup', false);
        };

        // todo: 在頁籤內刪除會有錯誤<
        // 因為一刪除就會去下一個變更項目，還來不及呼叫checkTransaction，
        const popupConfirm = async () => {
            isLoading.value = true;
            if (aplCatl === aplCatlCode.POLICY) {
                // 保單變更要先呼叫beforeCancelTransactionItem
                // 有提示訊息確認之後在呼叫removeItem，無提示訊息直接呼叫removeItem刪除
                const { msg, success } = await beforeCancelItem(code.value);
                if (msg && success) {
                    modalContent.value = {
                        id: 'confirm2',
                        content: msg,
                    };
                    setTimeout(() => {
                        isLoading.value = false;
                    }, 1500);
                } else if (success) {
                    removeService();
                } else {
                    handleClose();
                }
            } else {
                // 除了640，其他項目只有一個交易項目，刪除即回首頁
                emit('goNext');
                handleClose();
            }
        };

        /** 刪除變更項目之後
         * @param {Boolean} needcheckTransaction 是否需要call checkTransaction()
         */
        const removeService = async (needcheckTransaction) => {
            cancelTransactionItem(code.value).then(res => {
                if (res.data?.status) {
                    store.dispatch('services/removeService', code.value);
                    if (res.data?.actionList?.length >= 0) {
                        const addItemArr = res.data.actionList.map(i => {
                            // action= 'add' 新增選項，action＝edit存在選項 不知道未來
                            // 目前是已有填寫的變更項目清空重填
                            if (i.action === 'add' || i.action === 'edit') {
                                return i.itemNo;
                            }
                        });
                        if (addItemArr?.length) {
                            addAndInsertService(addItemArr, code);
                        }
                    }
                    emit('goNext');

                    if (needcheckTransaction && route.name === routeName.CONFIRM_DATA) {
                        // 在資料確認頁的部分才需要取得需要補填的變更項目內容，並轉頁過去開始申請
                        // 如果是處於變更流程按下垃圾桶，在流程申請完畢都會打這支api
                        checkTransaction().then(async (res) => {
                            if (res.data?.checkTransactionList.length > 0) {
                                const addItemList = res.data.checkTransactionList.map(i => {
                                    store.dispatch('services/removeService', i.itemNo);
                                    return i.itemNo;
                                });
                                const { isNext } = await addService(addItemList);
                                if (isNext) {
                                    const serviceList = store.state.services.serviceList;
                                    const list = addItemList.map(i => {
                                        const obj = serviceList.find(k => k.transactionItemNo === i);
                                        if (obj) return obj;
                                    });
                                    store.dispatch('services/setServices', list);
                                    router.push({ name: list[0].routeName }).catch(error => { console.log(error); });
                                }
                            }
                        });
                    } else {
                        handleClose();
                    }
                }
            }).catch(() => {
                handleClose();
            });
        };
        return {
            visible,
            isLoading,
            handleClose,
            popupConfirm,
            removeService,
            modalContent
        };
    }
};
</script>
